export default {
  blik__title: 'Dokonaj płatności przelewem BLIK',
  blik__intro: 'Aby zakończyć płatność, wykonaj przelew na numer telefonu poniżej.',

  blik__phone_label: 'Wykonaj przelew na ten numer',
  blik__full_name_label: 'Imię i nazwisko odbiorcy',
  blik__amount_label: 'Kwota do przelania',
  blik__time_remaining: 'Pozostały czas',

  blik__step_1: 'Otwórz aplikację bankową (lub bankowość internetową).',
  blik__step_2: 'Wybierz przelew na numer telefonu (BLIK P2P).',
  blik__step_3: 'Wpisz numer telefonu: <b>{customer_phone}</b>',
  blik__step_4: 'Upewnij się, że imię i nazwisko odbiorcy są zgodne. Jeśli pole nie jest obowiązkowe — pomiń ten krok.',
  blik__step_5: 'Wpisz kwotę: <b>{amount} {currency}</b>',
  blik__step_6: 'Potwierdź przelew i wróć na tę stronę.',

  blik__after_transfer:
    'Po zaksięgowaniu przelewu status płatności zaktualizuje się automatycznie. Może to potrwać chwilę.',

  blik__info_banner: 'Wykonaj przelew w aplikacji bankowej, aby potwierdzić płatność.',

  blik__btn_confirm: 'Wykonałem/-am przelew',
  blik__btn_cancel: 'Anuluj i wróć',

  blik__note_1: 'Jeśli nie wykonasz przelewu, płatność nie zostanie potwierdzona.',
  blik__note_2: 'Jeśli instrukcja wygaśnie (jeśli wyświetlono), utwórz nową płatność i spróbuj ponownie.',
};
